import React, { useEffect, useState } from "react";
import fetch from "../../utils/fetch";
import BlogCard from "./BlogCard";
import BlogCardSkeleton from "./BlogCardSkeleton";
import { BlogSlider } from "./BlogSlider";

type BlogRelatedArticleProps = {
  title: string;
  tags: string;
};

const BlogRelatedArticle = ({ title, tags }: BlogRelatedArticleProps) => {
  const [blogData, setBlogData] = useState(null);
  const [isLoadingRelated, setIsLoadingRelated] = useState(true);

  const getBlogList = async () => {
    const { status, data } = await fetch(
      "GET",
      `/kentico/blog`,
      {
        limit: 6, //take 6 to overcome section must show 4 blog exclude the currently visited blog
        slug: tags ? tags : ""
      },
      true
    );

    if (status == 200) {
      let rawData = [];

      //to filter only blog with title not same as currently visited will show up
      data.item.map((data) => {
        if (data.title !== title) {
          rawData.push(data);
        }
      });
      if (rawData.length % 2 !== 0) {
        setBlogData(rawData);
      } else {
        rawData.splice(-1);
        setBlogData(rawData);
      }
      //take only for if in before filter it keep takes 5 blogs
      setIsLoadingRelated(false);
    }
  };

  useEffect(() => {
    getBlogList();
  }, [title, tags]);

  return (
    <div className="blog-related-wrapper">
      {!isLoadingRelated && (
        <div>
          <div className="blog-related-section-title">Baca Juga</div>
          <div className="blog-card-wrapper">
            {isLoadingRelated ? (
              <BlogSlider maxWidth="1040px">
                <BlogCardSkeleton></BlogCardSkeleton>
              </BlogSlider>
            ) : (
              <BlogSlider maxWidth="1040px">
                {blogData &&
                  blogData.map((data, key) => {
                    return (
                      <div key={key}>
                        <BlogCard
                          key={data.slug}
                          thumbnail={data.thumbnail}
                          title={data.title}
                          excerpt={data.excerpt}
                          slug={data.slug}
                          tags={data.tags}
                        />
                      </div>
                    );
                  })}
              </BlogSlider>
            )}
          </div>
        </div>
      )}
      <style jsx>{`
        .blog-related-wrapper {
          margin-bottom: 24px;
          max-width: 1040px;
          width: 100%;
        }
        .blog-related-section-title {
          text-align: left;
          font-size: 24px;
          font-weight: bold;
          margin-bottom: 24px;
          margin-left: 16px;
        }
        .blog-card-wrapper {
          display: flex;
          width: 100%;
          max-width: 1040px;
          min-height: 398.6px;
        }
        @media only screen and (max-width: 730px) {
          .blog-related-wrapper {
            margin-bottom: 24px;
            margin-top: 36px;
          }
        }
      `}</style>
    </div>
  );
};

export default BlogRelatedArticle;
